import { object, string, mixed } from 'yup';
import {
  nameRegex,
  addressRegex,
  zipCodeRegex,
  phoneRegex,
  emailRegex
} from './validation-rules';

export const registerSchema = object({
  firstName: string()
    .required('First Name is required')
    .matches(nameRegex, 'First Name must contain English letters only'),
  lastName: string()
    .required('Last Name is required')
    .matches(nameRegex, 'Last Name must contain English letters only'),
  company: string().matches(
    addressRegex,
    "Company Name must contain only: English letters, digits and -.,&#()'/ symbols"
  ),
  address1: string()
    .required('Address Line 1 is required')
    .matches(
      addressRegex,
      "Address Line must contain only: English letters, digits and -.,&#()'/ symbols"
    ),
  address2: string()
    .nullable()
    .matches(
      addressRegex,
      "Address Line must contain only: English letters, digits and -.,&#()'/ symbols"
    ),
  city: string()
    .required('City is required')
    .matches(nameRegex, 'City must contain English letters only'),
  state: mixed().test('not-empty', 'State is required', value => {
    return value;
  }),
  zipcode: string()
    .required('Zip Code is required')
    .matches(zipCodeRegex, 'Invalid zip code format')
    .min(5, 'Invalid zip code length'),
  phone: string()
    .required('Phone is required')
    .min(11, 'Invalid phone number length')
    .matches(phoneRegex),
  email: string()
    .required('Email Address is required')
    .matches(emailRegex, 'Invalid email format')
});
